// ----------------------------------------------------
// src/Redux/Store.js
// ----------------------------------------------------

import { configureStore } from "@reduxjs/toolkit";
import routesReducer from "../Slice/RouteSlice";
import heroReducer from "../Slice/HeroSlice";
import purposeReducer from "../Slice/PurposeSlice";
import serviceReducer from "../Slice/serviceSlice";
import ReviewReducer from "../Slice/ReviewSlice";
import ContactReducer from "../Slice/ContactSlice";

export const store = configureStore({
  reducer: {
    routes: routesReducer,
    hero: heroReducer,
    purpose: purposeReducer,
    service: serviceReducer,
    review: ReviewReducer,
    contact: ContactReducer,
  },
});